import { createFileRoute } from '@tanstack/react-router';
import { Callback } from 'src/oauth/Callback';

export const Route = createFileRoute('/callback')({
  component: Callback,
});
